import { render } from "./accountMigrate.vue?vue&type=template&id=4ae6747e&scoped=true"
import script from "./accountMigrate.vue?vue&type=script&lang=js"
export * from "./accountMigrate.vue?vue&type=script&lang=js"

import "./accountMigrate.vue?vue&type=style&index=0&id=4ae6747e&lang=less&scoped=true"
import "./accountMigrate.vue?vue&type=style&index=1&id=4ae6747e&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae6747e"]])

export default __exports__